// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackSquareFilledSvg from "@ant-design/icons-svg/es/asn/SlackSquareFilled";
import AntdIcon from '../components/AntdIcon';

var SlackSquareFilled = function SlackSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareFilledSvg
  }));
};

SlackSquareFilled.displayName = 'SlackSquareFilled';
export default React.forwardRef(SlackSquareFilled);